import * as React from "react";

function SvgFacebook(props, svgRef) {
  return <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M18 9a9 9 0 00-9-9 9 9 0 00-9 9 9.001 9.001 0 007.594 8.891v-6.29H5.309V9h2.285V7.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.136c-1.118 0-1.466.695-1.466 1.407V9h2.496l-.399 2.602h-2.097v6.289A9.001 9.001 0 0018 9z" fill="#fff" /></svg>;
}

const ForwardRef = React.forwardRef(SvgFacebook);
export default ForwardRef;